import React, { useState } from 'react';
import {
    Container,
    Typography,
    Card,
    CardContent,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Paper,
    Grid,
    Button,
    Box,
    Snackbar,
    IconButton
} from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../Auth/AuthProvider';
import { can } from '../../Conections/LogConections';
import { Calificar, GetActivityDataAPI, GetEstudentsDataAPI, GetPointsDataAPI, SetEstudentArrayCreate } from '../../Conections/AcademicConection';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

// Datos de ejemplo
const actividadEjemplo = {
    nombre: "",
    peso: 0
};

const estudiantesEjemplo = [
    { id: 0, nombre: "" }
];

const puntosEjemplo = [
    { id: 0, nombre: "" }
];

function GradeUp() {

    const location = useLocation();
    const goTo = useNavigate();
    const { getToken, getCompany } = useAuth();
    const params = useParams();

    const [actividadTitle, setActividadTitle] = useState("");
    const [actividad, setActividad] = useState(actividadEjemplo);
    const [estudiantes, setEstudiantes] = useState(estudiantesEjemplo);
    const [puntos, setPuntos] = useState(puntosEjemplo);
    const [calificaciones, setCalificaciones] = useState(
        estudiantes.reduce((acc, estudiante) => ({
            ...acc,
            [estudiante.id]: puntos.reduce((puntosAcc, punto) => ({
                ...puntosAcc,
                [punto.id]: ''
            }), {})
        }), {})
    );
    const [openSnackbar, setOpenSnackbar] = useState(false);

    React.useEffect(() => {
        async function reloaduser() {
            if (getToken()) {
                const permisionCan = await can(getToken(), getCompany(), "/academic/gradeupone/:activity");
                if (permisionCan === 0) {
                    goTo("/dashboard");
                }
                else {
                    const numeros = location.state?.idsSeleccionados || [];
                    let Activity = await GetActivityDataAPI(getToken(), getCompany(), params["activity"]);
                    let Estudents = await GetEstudentsDataAPI(getToken(), getCompany(), Activity["group"]);
                    let Points = await GetPointsDataAPI(getToken(), getCompany(), params["activity"]);

                    let actividadChange = actividad;
                    actividadChange["id"] = Activity["id"];
                    setActividadTitle(Activity["name"]);
                    actividadChange["nombre"] = Activity["name"];
                    actividadChange["descripcion"] = Activity["description"];
                    actividadChange["peso"] = Activity["weigth"];
                    actividadChange["fecha"] = Activity["date"];
                    actividadChange["activa"] = Activity["show"] === 1;
                    setActividad(actividadChange);

                    const listEstudents = Estudents.map(Estudent => ({
                        id: Estudent.id,
                        nombre: Estudent.lastname + ", " + Estudent.firstname
                    }));
                    setEstudiantes(listEstudents);

                    const listPoint = Points.map(Point => ({
                        id: Point.id,
                        nombre: Point.text
                    }));
                    setPuntos(listPoint);

                    setCalificaciones(listEstudents.reduce((acc, estudiante) => ({
                        ...acc,
                        [estudiante.id]: listPoint.reduce((puntosAcc, punto) => ({
                            ...puntosAcc,
                            [punto.id]: ""
                        }), {})
                    }), {}));

                }
            }
            else {
                goTo(`/login`);
            }
        };
        reloaduser();
    }, [params, actividad, getCompany, getToken, goTo, actividadTitle, location]);

    const handleCalificacionChange = (estudianteId, puntoId, valor) => {
        const numeroValor = Number(valor);
        if (isNaN(numeroValor) || numeroValor < 0 || numeroValor > 100) return;

        setCalificaciones(prevCalificaciones => ({
            ...prevCalificaciones,
            [estudianteId]: {
                ...prevCalificaciones[estudianteId],
                [puntoId]: valor
            }
        }));
    };

    const handleEnviarNotas = async () => {
        const datos = await Calificar(
            getToken(),
            getCompany(),
            params["activity"],
            calificaciones
        );
        goTo(`/academic/gradeshow/${datos}`);
    };

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    const handleVerResultados = () => {
        goTo(`/academic/gradeshow/${actividad.id}`);
    };

    const handleSubirNotasPorGrupo = () => {
        goTo(`/academic/gradeupone/${actividad.id}`);
    };

    const handlePrincipal = () => {
        goTo("/academic/showactivity/" + actividad.id);
    };

    return (
        <Container maxWidth="lg">
            <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ my: 4 }}>
                Subir Notas
            </Typography>

            <Grid container spacing={3} direction="column">
                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                <IconButton onClick={() => handlePrincipal()} color="primary">
                                    <ArrowBackIosIcon />
                                </IconButton>
                                Datos de la Actividad
                            </Typography>
                            <Typography variant="body1">
                                <strong>Nombre:</strong> {actividad.nombre}
                            </Typography>
                            <Typography variant="body1">
                                <strong>Peso:</strong> {actividad.peso}%
                            </Typography>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleVerResultados}
                                    sx={{ mt: 2 }}
                                >
                                    Ver Resultados
                                </Button>
                                <Button
                                    variant="contained"
                                    color="success"
                                    onClick={handleSubirNotasPorGrupo}
                                    sx={{ mt: 2 }}
                                >
                                    Subir notas por grupos
                                </Button>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Calificaciones
                            </Typography>
                            <Box sx={{ overflow: 'auto', maxWidth: '100%' }}>
                                <Box sx={{ width: '100%', display: 'table', tableLayout: 'fixed' }}>
                                    <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
                                        <Table stickyHeader>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ minWidth: 200, position: 'sticky', left: 0, background: 'white', zIndex: 1000 }}>Estudiante</TableCell>
                                                    {puntos.map(punto => (
                                                        <TableCell key={punto.id} align="center" sx={{ minWidth: 120 }}>{punto.nombre}</TableCell>
                                                    ))}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {estudiantes.map(estudiante => (
                                                    <TableRow key={estudiante.id}>
                                                        <TableCell component="th" scope="row" sx={{ position: 'sticky', left: 0, background: 'white', zIndex: 1 }}>
                                                            {estudiante.nombre}
                                                        </TableCell>
                                                        {puntos.map(punto => (
                                                            <TableCell key={punto.id} align="center">
                                                                <TextField
                                                                    type="number"
                                                                    InputProps={{
                                                                        inputProps: {
                                                                            min: 0,
                                                                            max: 100,
                                                                            step: 1
                                                                        }
                                                                    }}
                                                                    value={calificaciones[estudiante.id][punto.id]}
                                                                    onChange={(e) => handleCalificacionChange(estudiante.id, punto.id, e.target.value)}
                                                                    variant="outlined"
                                                                    size="small"
                                                                    sx={{ width: '70px' }}
                                                                />
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            </Box>
                            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                                <Button variant="contained" color="primary" onClick={handleEnviarNotas}>
                                    Enviar Notas
                                </Button>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Contenido Adicional
                            </Typography>
                            <Typography variant="body1">
                                Esta tarjeta está reservada para funcionalidades adicionales.
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: '100%' }}>
                    Notas enviadas exitosamente!
                </Alert>
            </Snackbar>
        </Container>
    );
}

export default GradeUp;

